// extracted by mini-css-extract-plugin
module.exports = {"title":"planDetailSummary_title__HOux5","list":"planDetailSummary_list__iIHSw","listItem":"planDetailSummary_listItem__tLw8Q","inactive":"planDetailSummary_inactive__itw1p"};